import React from 'react';
import PropTypes from 'prop-types';

// Удобный ввод длительности: отдельные сегменты ч/мин/сек со степперами и клавишами-стрелками.
// Хранит и отдаёт значение в секундах — снаружи работаем только с числом секунд.
function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
}

function Segment({ caption, value, max, onCommit }) {
    const step = (delta) => onCommit(clamp(value + delta, 0, max));
    const handleType = (e) => {
        const digits = e.target.value.replace(/\D/g, '').slice(-2);
        onCommit(clamp(parseInt(digits || '0', 10), 0, max));
    };
    const handleKey = (e) => {
        if (e.key === 'ArrowUp') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowDown') { e.preventDefault(); step(-1); }
    };
    return (
        <div className="hms-seg">
            <input
                className="hms-field"
                inputMode="numeric"
                value={String(value).padStart(2, '0')}
                onChange={handleType}
                onKeyDown={handleKey}
                onFocus={(e) => e.target.select()}
            />
            <span className="hms-cap">{caption}</span>
        </div>
    );
}

Segment.propTypes = {
    caption: PropTypes.string.isRequired,
    value: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    onCommit: PropTypes.func.isRequired
};

export default function HmsInput({ label, seconds, onChange, maxHours }) {
    const total = Math.max(0, parseInt(seconds, 10) || 0);
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = total % 60;

    const emit = (nh, nm, ns) => onChange(nh * 3600 + nm * 60 + ns);

    return (
        <div className="hms">
            {label && <label className="ctl-label">{label}</label>}
            <div className="hms-row">
                <Segment caption="час" value={h} max={maxHours} onCommit={(v) => emit(v, m, s)} />
                <span className="hms-colon">:</span>
                <Segment caption="мин" value={m} max={59} onCommit={(v) => emit(h, v, s)} />
                <span className="hms-colon">:</span>
                <Segment caption="сек" value={s} max={59} onCommit={(v) => emit(h, m, v)} />
            </div>
        </div>
    );
}

HmsInput.propTypes = {
    label: PropTypes.string,
    seconds: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    onChange: PropTypes.func.isRequired,
    maxHours: PropTypes.number
};

HmsInput.defaultProps = {
    label: undefined,
    maxHours: 23
};
